import React from "react";

const RenderButton = ({
  disabled = false,
  label,
  onClick,
  className,
  value,
  key = 0,
  style,
}) => {
  return (
    <button
      disabled={disabled}
      key={key}
      type="button"
      style={{
        borderWidth: 1,
        alignItems: "center",
        justifyContent: "center",
        width: 100,
        height: 40,
        // backgroundColor:'#fff',
        borderRadius: 50,
      }}
      onClick={onClick}
      value={value}
      className={className + " mb-1"}
    >
      {label}
    </button>
  );
};

export default RenderButton;
